module.exports = __webpack_public_path__ + "static/media/Icon-PDF-register.5e083d56.png";